import React from "react";
import { format, parse, isValid } from 'date-fns';

const InputDateAndTime = ({ title, value, onChange, className }) => {
    const baseClassName = 'w-1/2 border-airpark-gray-300 hover:border-airpark-gray-400 border-2 h-11 rounded-xl pl-2 pr-2 text-airpark-green font-medium text-center last:ml-2 focus:outline-none';

    // Ensure we have a valid date, fallback to current date if invalid
    const safeValue = value && isValid(new Date(value)) ? new Date(value) : new Date();

    if (!className) {
        className = baseClassName;
    } else {
        className = `${baseClassName} ${className}`;
    }

    const handleDateChange = (date) => {
        if (!date) return;
        
        try {
            const timeString = format(safeValue, 'HH:mm');
            const updatedDateString = `${date} ${timeString}`;
            const updatedDate = parse(updatedDateString, 'yyyy-MM-dd HH:mm', new Date());
            
            if (isValid(updatedDate)) {
                onChange(updatedDate);
            }
        } catch (error) {
            console.error('Error updating date:', error);
        }
    }

    const handleTimeChange = (time) => {
        if (!time) return;
        
        try {
            const dateString = format(safeValue, 'yyyy-MM-dd');
            const updatedDateString = `${dateString} ${time}`;
            const updatedDate = parse(updatedDateString, 'yyyy-MM-dd HH:mm', new Date());
            
            if (isValid(updatedDate)) {
                onChange(updatedDate);
            }
        } catch (error) {
            console.error('Error updating time:', error);
        }
    }

    return (
        <div>
            {title && <span className="font-medium pb-1">{title}</span>}
            <div className="flex flex-row">
                <input 
                    value={format(safeValue, 'yyyy-MM-dd')} 
                    onChange={(e) => handleDateChange(e.target.value)} 
                    type="date" 
                    className={className} 
                />
                <input 
                    value={format(safeValue, 'HH:mm')} 
                    onChange={(e) => handleTimeChange(e.target.value)} 
                    type="time" 
                    className={className} 
                />
            </div>
        </div>
    );
};

export default InputDateAndTime;